// Загрузка доступных устройств
export const MEASUREMENTS_DEVICES_REQUEST =
    "measurements/DEVICES_REQUEST";

export const MEASUREMENTS_DEVICES_SUCCESS =
    "measurements/DEVICES_SUCCESS";

export const MEASUREMENTS_DEVICES_FAILURE =
    "measurements/DEVICES_FAILURE";

// Загрузка данных расхода
export const MEASUREMENTS_DATA_REQUEST =
    "measurements/DATA_REQUEST";

export const MEASUREMENTS_DATA_SUCCESS =
    "measurements/DATA_SUCCESS";

export const MEASUREMENTS_DATA_FAILURE =
    "measurements/DATA_FAILURE";

// Применение фильтра
export const MEASUREMENTS_FILTER_APPLY =
    "measurements/FILTER_APPLY";

// Очистка состояния страницы
export const MEASUREMENTS_RESET =
    "measurements/RESET";